import React, { useMemo } from 'react';
import styles from './bubbleMsg.module.scss';
import Button from '../Button/ButtonComponent';
import { ReactSVG } from 'react-svg';
import { dataResources } from '@portal-internet/core';
const { basePath } = dataResources;

function BubbleMsg({showMsg, setShowMsg, type, content, title="INFORMACIÓ"}) {

    const _printItemsList = () => {
        if (content.length) {
            return content.map((item, index) => (
                <li key={index}>{item}</li>
            ))
        }
        return (<li>No hi ha cap ítem</li>)
    }

    const _printContent = () => {
        switch (type) {
            case "list":
                return (<ul>{_printItemsList()}</ul>)
            default:
                return content;
        }
    }

    if (showMsg) {
        return (
            <div className={styles.redlMsg} data-testid={`REDL-bottom-bubbleMsg-${type}`}>
                <div className={styles.redlMsgWrapper}>
                    <div className={styles.redlMsgHeader}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <ReactSVG
                                beforeInjection={svg => {
                                    svg.setAttribute('width', '20px');
                                    svg.setAttribute('height', '20px');
                                    svg.style.marginRight = '0.3rem';
                                }}
                                src={basePath + '/_resources/REDL/icons/info-circle-fill.svg?v=JIT_ENV_RESOURCES_VERSION'} size={20} />
                            {title}
                        </div>
                        <Button variant="tertiary" size="sm" title="Tancar" onClick={(ev) => { setShowMsg(false) }}
                        >
                            <ReactSVG
                                src={basePath + '/_resources/REDL/icons/x-lg.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                        </Button>
                    </div>
                    {_printContent()}
                </div>
            </div>
        )
    }
    return null;
}

function areEqual(prevProps, nextProps) {
    return (
        JSON.stringify(prevProps.content) === JSON.stringify(nextProps.content) 
        && prevProps.showMsg === nextProps.showMsg  
    );
}

export default React.memo(BubbleMsg, areEqual);